export const SET_RECETA = "SET_RECETA";
export const GUARDAR_RECETA = "GUARDAR_RECETA";
